<template>
  <div id="main_div">

    <!-- About Start  -->
    <About/>
    <!-- About End -->

    <!-- WhyUs Section start -->
    <WhyUs/>
    <!-- WhyUs Section End -->

    <!-- Partners Section start -->
    <Partners/>
    <!-- Partners Section End -->

    <!-- Team Section Start -->
    <Team/>
    <!-- team Section End -->

    <!-- RecallForm Section Start -->
    <RecallForm/>
    <!-- RecallForm Section End -->
    <Map/>
    <!-- Footer Section start -->
    <Footer/>
    <!-- Footer Section End -->

    <js/>

  </div>
</template>
<script>
  export default {
    name: 'Company',
    beforeCreate: function () {
      document.body.className = ''
    }
  }
</script>
<!--remove comment below line to set color -->
<!--<style lang="css">-->
<!--@import '../public/assets/css/color/color-2.css';-->
<!--</style>-->



// WEBPACK FOOTER //
// src/pages/company_page.vue